import { START_DATE, useDatepicker } from '@datepicker-react/hooks';
import React, { useState } from 'react';
import DatePickerContextInner from '../DatePickerContext.inner.js';
import MonthContainer from './MonthContainer.inner.js';
import Icon from '../../Icon/Icon';
import * as S from '../DatePicker.styles.js';

const DatePickerContainer = ({
  onChange,
  value,
  minBookingDate,
  maxBookingDate,
  range,
  numberOfMonths = 2,
}) => {
  const [focusedInput, setFocusedInput] = useState(START_DATE);

  const onDatesChange = ({ focusedInput, ...data }) => {
    onChange && onChange(data);
    if (range) {
      setFocusedInput(focusedInput || START_DATE);
    }
  };

  const {
    firstDayOfWeek,
    activeMonths,
    focusedDate,
    goToPreviousMonths,
    goToNextMonths,
    ...context
  } = useDatepicker({
    ...value,
    minBookingDate,
    maxBookingDate,
    onDatesChange,
    focusedInput: focusedInput,
    numberOfMonths,
  });

  const isUnderLowerLimit =
    activeMonths[0]?.month <= minBookingDate?.getMonth() &&
    activeMonths[0]?.year <= minBookingDate?.getFullYear();
  const isOverUpperLimit =
    activeMonths[activeMonths.length - 1]?.month >=
      maxBookingDate?.getMonth() &&
    activeMonths[activeMonths.length - 1]?.year >=
      maxBookingDate?.getFullYear();

  const prevButton = isUnderLowerLimit ? {} : { onClick: goToPreviousMonths };

  const nextButton = isOverUpperLimit ? {} : { onClick: goToNextMonths };

  return (
    <DatePickerContextInner.Provider
      value={{
        focusedDate,
        range,
        ...context,
      }}
    >
      <S.NavButton {...prevButton} data-testid='navPrev'>
        <Icon
          name='chevron_left_outline'
          height={20}
          width={20}
          cursor='pointer'
          disabled={isUnderLowerLimit}
        />
      </S.NavButton>

      <S.DatePickerBody daily>
        <S.DatePickerDay numberOfMonths={numberOfMonths}>
          {activeMonths.map((month, index) => (
            <MonthContainer
              key={`${month.year}-${month.month}-${index}`}
              year={month.year}
              month={month.month}
              firstDayOfWeek={firstDayOfWeek}
            />
          ))}
        </S.DatePickerDay>
      </S.DatePickerBody>
      <S.NavButton {...nextButton} next={true} data-testid='navNext'>
        <Icon
          name='chevron_right_outline'
          height={20}
          width={20}
          cursor='pointer'
          disabled={isOverUpperLimit}
        />
      </S.NavButton>
    </DatePickerContextInner.Provider>
  );
};

export default DatePickerContainer;
